import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles((theme) => ({
  firstDiv: {
    display: "flex",
    marginTop: "40px",
    justifyContent: "flex-end",
  },
  button: {
    color: "#FFF",
    textTransform: "initial",
    "&:hover": {
      backgroundColor: theme.palette.primary.light,
    },
  },
}))

export default useStyles
